import { http } from "./httpServices";
import {
  APPEND_CART,
  CART,
  CHECKOUT,
  CLEARCART,
  GET_CART,
  PAYMENT,
  TICKET,
  UPDATE_CART,
  VERIFY,
} from "./constants";

export function appendCart(data) {
  return http.post(`${CHECKOUT}${APPEND_CART}`, data);
}

export function getCart(promo) {
  return http.get(`${CHECKOUT}${CART}${GET_CART}`, { params: { promo } });
}

export function updateCart(data) {
  return http.post(`${CHECKOUT}${UPDATE_CART}`, data);
}

export function checkoutCart(id, data) {
  return http.put(`${CHECKOUT}/${id}`, data);
}

export function checkoutTicket(id) {
  return http.get(`${CHECKOUT}${TICKET}`, { params: { id } });
}

export function clearCart() {
  return http.get(`${CHECKOUT}${CART}${CLEARCART}`);
}

export function verifyTransaction(transactionId) {
  return http.get(`${CHECKOUT}${PAYMENT}${VERIFY}`, {
    params: { transactionId },
  });
}
